<template>
    <div>

        <div class="bg-gray-100 rounded-full w-12 h-12 flex items-center justify-center shadow-sm mx-auto mb-4">
            <i class="far fa-lock text-2xl text-primary"></i>
        </div>


        <p class="text-gray-500 font-light mb-4 text-center">
            Sign up with your email
        </p>
        <tw-alert show v-if="hasErrors" type="error" :show-close="false" show-icon class="mt-6 mb-6">
            {{ errorMessage }}
        </tw-alert>
        <tw-form-group label="Email" :errors="errors" field="email_address">
            <input type="email" name="email" autocomplete="off" v-model="form.email_address" @keyup.enter="submit" autofocus>
        </tw-form-group>


        <div class="mt-6">
            <tw-button @click="submit" full size="lg" :busy="isLoading" busy-hide-text
                :disabled="form.email_address == null">
                Next
            </tw-button>
        </div>

    </div>
</template>

<script>
import FormErrors from '../../../classes/FormErrors'

export default {
    mixins: [
        FormErrors
    ],
    computed: {
        dates() {
            let max = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
            return {
                max: max.toISOString().substring(0, 10),
            }
        }
    },
    data: () => ({
        success: false,
        form: {
            email_address: null,
        }
    }),
    methods: {
        submit() {
            this.setLoading()
            Vue.axios.post('quote/client', this.form)
                .then(response => {
                    if (response.data.success) {
                        window.location.replace(`${this.$root.baseUrl}/quote/contact`);
                    } else {
                        this.setErrors({
                            response: {
                                data: response.data.feedback
                            }
                        });
                    }
                })
                .catch(errors => {
                    this.setErrors(errors);
                }).finally(() => this.setLoading(false));
        },
    }
}
</script>